import React from 'react';
import { motion } from 'framer-motion';
import { useIsMobile } from '../hooks/useMediaQuery';

const Projects: React.FC = () => {
  const isMobile = useIsMobile();
  
  const MotionWrapper = ({ children, ...props }: any) => {
    if (isMobile) {
      return <div>{children}</div>;
    }
    return <motion.div {...props}>{children}</motion.div>;
  };
  const projects = [
    {
      name: 'Pauze',
      logo: '/assets/pauze-logo.svg',
      description: 'Pauze is the tool for gamers who want to play intentionally, stay productive, and maintain a healthy rhythm between gaming and real life.',
      platforms: ['iOS', 'Android'],
      hasWebsite: true,
      websiteUrl: 'https://pauze.app/',
      status: 'active'
    },
    {
      name: 'Momu',
      logo: '/assets/momu.png',
      description: 'Momu is the AI journaling and community app for people who want to clear their mind, reflect with ease, and build a healthier relationship with their thoughts and emotions.',
      platforms: ['iOS', 'Android'],
      hasWebsite: true,
      websiteUrl: 'https://getmomu.app/',
      status: 'active'
    },
    {
      name: 'Propana',
      logo: '/assets/propana.svg',
      description: 'Coming soon',
      platforms: ['Web'],
      hasWebsite: false,
      status: 'coming-soon'
    }
  ];

  return (
    <section id="projects" className="bg-[#F22D5E] py-24">
      <div className="container mx-auto px-6">
        <MotionWrapper
          className="text-5xl md:text-6xl font-bold text-white text-center mb-20"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <h2>Current Projects</h2>
        </MotionWrapper>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
          {projects.map((project, index) => (
                 <MotionWrapper
                   key={project.name}
                   initial={{ opacity: 0, y: 50 }}
                   whileInView={{ opacity: 1, y: 0 }}
                   viewport={{ once: true }}
                   transition={{ duration: 0.8, delay: index * 0.1 }}
                   whileHover={isMobile ? {} : { y: -8, scale: 1.02 }}
                   className="bg-white rounded-2xl overflow-hidden hover:shadow-2xl transition-all duration-300 shadow-xl"
                 >
              {/* Logo section */}
              <div
                className={`p-10 text-center h-48 flex items-center justify-center ${
                  project.name === 'Pauze' 
                    ? 'bg-gradient-to-br from-purple-500 to-black' 
                    : 'bg-gray-50'
                }`}
              >
                <img 
                  src={project.logo} 
                  alt={`${project.name} Logo`} 
                  className={`mx-auto object-contain ${
                    project.name === 'Propana' 
                      ? 'w-64 h-64' 
                      : project.name === 'Pauze'
                      ? 'w-56 h-56'
                      : 'w-28 h-28'
                  }`}
                />
              </div>
              
              {/* Content section */}
              <div className="p-8">
                <h3 className="text-3xl font-bold text-gray-900 mb-4">{project.name}</h3>
                <p className="text-gray-600 mb-8 leading-relaxed text-lg">{project.description}</p>
                
                <div className="flex justify-start space-x-3 mb-8">
                  {project.platforms.map((platform) => (
                    <span
                      key={platform}
                      className="bg-gray-200 text-gray-700 px-3 py-1 rounded-full text-sm font-medium"
                    >
                      {platform}
                    </span>
                  ))}
                </div>
                
                {project.hasWebsite && (
                  <a
                    href={project.websiteUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-block text-gray-900 hover:text-pink-500 font-semibold transition-colors duration-300 text-lg"
                  >
                    Visit Website →
                  </a>
                )}
              </div>
            </MotionWrapper>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;
